<template>
  <div id="app">
    <b-overlay v-if="loading" :show="loading" style="height: 100vh;">
    </b-overlay>
    <b-container v-if="!loading">
      <nav-bar ref="navbar" @change="showSearch = $event"></nav-bar>
      <router-view />
    </b-container>
    <footer-bar />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FooterBar from "@/components/FooterBar.vue";
import axios from "axios";

export default {
  components: {
    NavBar,
    FooterBar
  },
  data: function() {
    return {
      showSearch: false,
      loading: true
    };
  },
  async created() {
    await axios.get("/conf/main.json").then(response => {
      this.$store.commit("setSiteData", response.data.api);
      this.loading = false;
      if (localStorage.clientId){
        this.getClientData();
      }
      
        
      
    });
  },
  methods:{
    async getClientData(){
      await axios
                .post(
                this.$store.state.user.siteData.location + "clients/clients/getOne",
                JSON.stringify({id: localStorage.clientId}),
                {
                    validateStatus(status) {
                    return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
                )
                .then(evtResponse => {
                    this.$store.dispatch('LogIn',evtResponse.data.records[0]);
                    this.$emit('login', evtResponse.data.records[0]);
                    console.log(this.$route.params);
                    if(this.$route.name === 'NoLogin' && this.$route.params.source){
                      this.$router.push('/' + this.$route.params.source);
                    }
                });
    },
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
</style>

<style lang="scss">
@import "./assets/style.scss";
</style>
